import { OrderOrderTypeEnum } from '@eih-netbroker/api-order';

export const OrderType = OrderOrderTypeEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OrderType = (typeof OrderType)[keyof typeof OrderType];
